import Repository from '@/repositories/marketing'
const resource = '/content_feeds'

export default {
    fetch(config){
        return Repository.get(`${resource}.json`,config)
    },
    create (data) {
        return Repository.post(`${resource}.json`, data)
    },
    getSelectedFeed(id)
    {
        return Repository.get(`${resource}/${id}.json`)
    },
    update(data,id)
    {
        return Repository.put(`${resource}/${id}.json`, data)
    }
} 